/**
 * The editor's panels by id: each one's title and component. Layouts arrange
 * these (the dock on desktop, the sheet on phones); the panels themselves
 * don't know which layout holds them, so neither layout keeps its own list.
 */
import type { FunctionComponent } from "react";
import { ConsolePanel } from "../console/ConsolePanel";
import { ContentBrowserPanel } from "../content-browser/ContentBrowserPanel";
import { InspectorPanel } from "../inspector/InspectorPanel";
import { OutlinerPanel } from "../outliner/OutlinerPanel";
import { StatisticsPanel } from "../statistics/StatisticsPanel";
import { ViewportPanel } from "../viewport/ViewportPanel";
import type { PanelId } from "./layout";

export interface PanelEntry {
  readonly title: string;
  readonly Component: FunctionComponent;
}

export const PANELS: Readonly<Record<PanelId, PanelEntry>> = {
  outliner: { title: "Outliner", Component: OutlinerPanel },
  viewport: { title: "Viewport", Component: ViewportPanel },
  inspector: { title: "Inspector", Component: InspectorPanel },
  contentBrowser: { title: "Content Browser", Component: ContentBrowserPanel },
  console: { title: "Console", Component: ConsolePanel },
  statistics: { title: "Statistics", Component: StatisticsPanel },
};
